var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgChild = function SvgChild(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 14.5335C10.8107 14.5335 13.1869 12.3066 13.9645 9.75006C14.1393 9.17533 15.3333 9.17533 15.3333 7.9335C15.3333 6.69166 14.128 6.6202 13.9329 6.01616C13.1241 3.5117 10.7736 1.3335 7.99999 1.3335C5.22482 1.3335 2.87323 3.51373 2.06574 6.02036C1.87155 6.6232 0.666656 6.66986 0.666656 7.9335C0.666656 9.19713 1.86407 9.19713 2.04496 9.78086C2.83222 12.3215 5.20059 14.5335 7.99999 14.5335Z",
    stroke: "#858C99",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9329 6.01616C13.1241 3.5117 10.7736 1.3335 8 1.3335",
    stroke: "#858C99",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36673 7.19993C6.36673 7.47537 6.292 7.7172 6.17993 7.8853C6.0671 8.05457 5.9295 8.13327 5.80007 8.13327C5.67063 8.13327 5.53303 8.05457 5.4202 7.8853C5.30813 7.7172 5.2334 7.47537 5.2334 7.19993C5.2334 6.9245 5.30813 6.68267 5.4202 6.51457C5.53303 6.3453 5.67063 6.2666 5.80007 6.2666C5.9295 6.2666 6.0671 6.3453 6.17993 6.51457C6.292 6.68267 6.36673 6.9245 6.36673 7.19993Z",
    fill: "#858C99",
    stroke: "#858C99",
    strokeWidth: 0.333333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7666 7.19993C10.7666 7.47537 10.6919 7.7172 10.5798 7.8853C10.467 8.05457 10.3294 8.13327 10.2 8.13327C10.0705 8.13327 9.93293 8.05457 9.8201 7.8853C9.70803 7.7172 9.6333 7.47537 9.6333 7.19993C9.6333 6.9245 9.70803 6.68267 9.8201 6.51457C9.93293 6.3453 10.0705 6.2666 10.2 6.2666C10.3294 6.2666 10.467 6.3453 10.5798 6.51457C10.6919 6.68267 10.7666 6.9245 10.7666 7.19993Z",
    fill: "#858C99",
    stroke: "#858C99",
    strokeWidth: 0.333333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16602 10.5835C6.80965 11.0167 7.42202 11.2333 8.00315 11.2333C8.58365 11.2333 9.15922 11.0172 9.72982 10.5849",
    fill: "#858C99"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16602 10.5835C6.80965 11.0167 7.42202 11.2333 8.00315 11.2333C8.58365 11.2333 9.15922 11.0172 9.72982 10.5849",
    stroke: "#858C99",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5761 2.06689C10.6655 2.71139 10.4689 3.18233 9.98643 3.47973C9.50397 3.77713 8.72007 3.91649 7.63477 3.89783",
    stroke: "#858C99",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgChild);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "child.85f8ab21fab9fed560db6a2070b73ae7.svg";